export default __webpack_public_path__ + "static/media/problema-10.659d977d.webp";